import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'minutesToHoursMinutes' })
export class MinutesToHoursMinutesPipe implements PipeTransform {
  transform(numberOfMinutes: number, minutesToRoundTo: number = 1): string {
    if (numberOfMinutes < minutesToRoundTo) {
      return `${numberOfMinutes}m`;
    }

    numberOfMinutes = Math.round(numberOfMinutes / minutesToRoundTo) * minutesToRoundTo;

    // Convert seconds to hours and minutes
    const hours = Math.floor(numberOfMinutes / 60);
    const minutes = numberOfMinutes % 60;

    if (numberOfMinutes < 60) {
      return `${minutes} min${minutes !== 1 ? 's' : ''}`;
    }

    const hrsStr = `${hours} hr${hours !== 1 ? 's' : ''}`;
    const minsStr = minutes > 0 ? ` ${minutes} min${minutes !== 1 ? 's' : ''}` : '';

    return hrsStr + minsStr;
  }
}
